import { useSelector } from "react-redux"
import { selectCurrency } from "../redux/shop/selectors"

export const usePrice = () => {
  const currency = useSelector(selectCurrency)

  const formatPrice = (value: number) => {
    const curr = currency || "KZT"
    return new Intl.NumberFormat("ru-KZ", {
      style: "currency",
      currency: curr === "KZT" ? "KZT" : curr,
      maximumFractionDigits: 0,
    }).format(Math.round(Number(value) || 0))
  }

  const countPrice = formatPrice

  const calcLineTotal = (price: number, qty = 1, totalPrice?: number | string) => {
    if (totalPrice != null && Number.isFinite(Number(totalPrice))) return Number(totalPrice)
    return (Number(price) || 0) * (qty || 1)
  }

  const calcCartTotal = (items: any[]) =>
      items.reduce((sum, it) => {
        const qty = it.totalQuantity ?? it.quantity ?? 1
        return sum + calcLineTotal(it.price, qty, it.totalPrice)
      }, 0)

  const countSalePrice = (price: number, discount = 10, quantity = 1) =>
      formatPrice((price - (price * discount) / 100) * quantity)

  const countTotalPrice = (array: any[]) =>
      formatPrice(
          array.reduce(
              (acc, { price, quantity, discountPercentage }) =>
                  acc + (price - (price * discountPercentage) / 100) * quantity,
              0,
          ),
      )

  const countTotalDiscount = (array: any[]) => {
    let totalDiscount = 0
    array.forEach(({ price, quantity, discountPercentage }) => {
      if (discountPercentage >= 10) {
        totalDiscount += (price * discountPercentage) / 100 * quantity
      }
    })
    return formatPrice(totalDiscount)
  }

  return {
    formatPrice,
    calcLineTotal,
    calcCartTotal,
    countPrice,
    countSalePrice,
    countTotalPrice,
    countTotalDiscount,
  }
}
